// extracted by mini-css-extract-plugin
module.exports = {"input":"stepper_input__ZZLPE"};